import {useContext, useEffect, useState} from "react";
import Header from "../../components/Header.js";
import BackButton from "../../components/BackButton.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleUp, } from "@fortawesome/free-solid-svg-icons";
import Input from "../../components/Input";
import ReactSelect from "../../components/Select/ReactSelect";
import Button from "../../components/Button";
import {useLocation, useNavigate} from "react-router-dom";
import {ThemeContext} from "../../contexts/ThemeContextProvider";
import { useTokenCache } from "../../contexts/TokenCache";
import {UserService as userService} from "../../services/user.service";
import {OrganisationService} from "../../services/organisation.service";
import ReactTable from "../../components/ReactTable/ReactTable";
import downloadFile from "../../_helpers/downloadFile";
import UsersBulkUpload from "./UsersBulkUpload";

export default function UserManagementPage(props) {

    const [values, setValues] = useState();
    const [openFilters, setOpenFilters] = useState(false);
    const [users, setUsers] = useState();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [organisations, setOrganisations] = useState();
    const [searching, setSearching] = useState(false);
    const [sortOptions, setSortOptions] = useState({accessor: '', direction: ''});
    const [sorting, setSorting] = useState(false);

    const {state} = useLocation();

    const context = useContext(ThemeContext);
    const { groups } = useTokenCache();

    let navigate = useNavigate();

    const userStatuses = [
        {value: "CONFIRMED", label: "Confirmed"},
        {value: "FORCE_CHANGE_PASSWORD", label: "Force change Password"},
    ];

    const userEnabledValues = [
        {value: "Enabled", label: "Enabled"},
        {value: "Disabled", label: "Disabled"},
    ];

    function getUsers(csv, pageNumber, pageSize) {
        userService
            .getUsers(csv, pageSize, pageNumber, sortOptions)
            .then((response) => {
                setUsers(response.data);
                // setUsers(usersData);
                setLoadingUsers(false);
            })
            .catch((error) => {
                setUsers({});
                setLoadingUsers(false);
                console.log(error);
            });
    }

    function getOrganisations() {
        if (groups.includes("ontrac-admin-group")) {
            OrganisationService.getAllOrganisations().then((response) => {
                setOrganisations(response.data);
            }).catch((error) => {
                setOrganisations({});
                console.log(error);
            })
        }
    } 

    useEffect(() => {
        getUsers()
        getOrganisations()
    }, []);

    useEffect(() => {
        if (users?.results.length > 0) {
            handleSubmit(undefined, 10, sortOptions);
        }
    }, [sortOptions])

    function handleInputChange(e) {
        setValues((values) => ({...values, [e.target.name]: e.target.value}));
    }

    const handleInputChangeG = (e, name) => {
        setValues((values) => ({
            ...values,
            [name]: e ? e : "",
        }));
    };

    function handleSubmit(pageVal, pageSizeVal) {
        let pageNumber = pageVal === 0 ? 0 : pageVal || page || 0;
        let pageSizeNumber = pageSizeVal === 0 ? 0 : pageSizeVal || pageSize || 0;
        setPage(pageNumber);
        setPageSize(pageSizeNumber);
        if (!searching) {
            getUsers(false, pageNumber, pageSizeNumber);
        } else {
            handleSearch(pageNumber, pageSizeNumber);
        }
    }

    function handleSearch(pageNumber, pageSizeNumber) {
        setLoadingUsers(true);
        setSearching(true);
        userService.userSearch(values, false, pageNumber, pageSizeNumber, sortOptions)
            .then((response) => {
                setUsers(response.data);
                setLoadingUsers(false);
            })
            .catch((error) => {
                console.log(error);
                setUsers({error});
                setLoadingUsers(false);
            })
    }

    const handleExportUsers = () => {
        if (values) {
            userService
                .userSearch(values, true)
                .then((response) => {
                    downloadFile(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            userService.getUsers(true)
                .then((response) => {
                    downloadFile(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    };

    function handleReset() {
        setValues(null);
        setSearching(false);
        setPage(0);
        setPageSize(10);
        userService
            .getUsers(false, 10, 0)
            .then((response) => {
                setUsers(response.data);
                setLoadingUsers(false);
            })
            .catch((error) => {
                setUsers({});
                setLoadingUsers(false);
                console.log(error);
            });
    }

    const handlePageSize = (val) => {
        setPage(page);
        setPageSize(val);
    };

    const handleTableSort = (accessor) => {
        let direction = sortOptions?.direction;

        if (!direction) {
            direction = 'dsc';
            setSorting(true);
        } else if (direction === 'dsc') {
            direction = 'asc';
            setSorting(true);
        } else {
            direction = '';
        }

        setSortOptions({
            accessor: accessor,
            direction: direction
        });
    }

    const handleOpenCurrentUserDetails = (e, row) => {
        navigate("/userdetails", {
            state: { data: row.row?.original, title: "User Details", formType: "userdetails" },
        });
    };

    return (
        <div className="page" id="userManagementPage">
            <Header title="User Management"/>
            <BackButton
                setPage={props.setPage}
                target={["usermanagementDash", "backward"]}
                navigateUrl="/usermanagementDash"
            />

            <div className="filter-form">
                <div className="filter-form__controller">
                    <h2 className="filter-form__title inline-block">
                        Users Search Filters
                    </h2>

                    {openFilters ? (
                        <FontAwesomeIcon
                            className="inline-block filter-icon"
                            icon={faAngleUp}
                            onClick={() => setOpenFilters(!openFilters)}
                            title="Collapse"
                        />
                    ) : (
                        <FontAwesomeIcon
                            className="inline-block filter-icon"
                            icon={faAngleDown}
                            onClick={() => setOpenFilters(!openFilters)}
                            title="Expand"
                        />
                    )}
                </div>

                {openFilters && (
                    <div>
                        <div className="filter-form__group fields-wrapper">
                            <Input
                                name="firstName"
                                label="First Name"
                                value={values?.firstName}
                                onChange={handleInputChange}
                            />
                            <Input
                                name="surname"
                                label="Surname"
                                value={values?.surname}
                                onChange={handleInputChange}
                            />
                            <Input
                                name="email"
                                label="Email"
                                value={values?.email}
                                onChange={handleInputChange}
                            />
                            {groups.includes("ontrac-admin-group") && (
                                <ReactSelect
                                    name="organisation"
                                    label="Organisation"
                                    placeholder="Select an Organisation"
                                    data={organisations}
                                    valueLabel={["organisation_name"]}
                                    value={values?.organisation}
                                    onChange={handleInputChangeG}
                                />
                            )}
                            {groups.includes("ontrac-admin-group") && (
                                <ReactSelect
                                    name="userStatus"
                                    label="User Status"
                                    placeholder="Select User Status"
                                    data={userStatuses}
                                    valueLabel={["label"]}
                                    value={values?.userStatus}
                                    onChange={handleInputChangeG}
                                />
                            )}
                            <ReactSelect
                                name="enabled"
                                label="User Enabled Status"
                                placeholder="Select Enabled Status"
                                data={userEnabledValues}
                                valueLabel={["label"]}
                                value={values?.enabled}
                                onChange={handleInputChangeG}
                            />
                        </div>

                        <div className="button-group filter-form__submit">
                            <Button action="secondary" label="Reset" onClick={handleReset}/>
                            <Button action="primary" label="Filter" onClick={() => handleSearch(page, pageSize)}/>
                        </div>
                    </div>
                )}
            </div>

            {!loadingUsers && users !== "error" && users?.results?.length > 0 && (
                <>
                    <h2>Current Users</h2>
                    <ReactTable
                        tableData={users?.results}
                        showColumns={users?.headers}
                        canOpen={true}
                        handleOpen={handleOpenCurrentUserDetails}
                        customHeader={true}
                        customSearch={true}
                        currentPage={users?.pageNumber}
                        totalPages={users?.totalPages}
                        pageSize={users?.pageSize}
                        totalElements={users?.totalElements}
                        setPage={(val) => {
                            setPage(val);
                            handleSubmit(val, undefined);
                        }}
                        setPageSize={(val) => {
                            handlePageSize(val);
                            handleSubmit(0, val);
                        }}
                        sortOptions={sortOptions}
                        setSortOptions={setSortOptions}
                        handleTableSort={handleTableSort}
                    ></ReactTable>
                    <div className="button-group">
                        <Button action="secondary" label="Export Users" onClick={handleExportUsers}/>
                        {groups.includes("ontrac-admin-group") && <Button
                            action="primary"
                            label="Add User"
                            onClick={() => navigate("/adminAddUser")}
                        />}
                    </div>
                </>
            )}
            
            {!loadingUsers && Array.isArray(users) && users?.length === 0 && (
               <h2>There are no users</h2>
            )}

            {!loadingUsers && users === "error" && (
                <h2>Unable to fetch users</h2>
            )}

            {groups.includes("ontrac-admin-group") && (
                <UsersBulkUpload />
            )}
        </div>
    );    
}